import { lazy } from 'react'

export const LogRoutes = [
    {
        path: '/log/activity-types',
        component: lazy(() => import('../views/activity-types')),
        meta: {
            action: 'call',
            resource: 'LOG_VIEW_ACTIVITY_TYPES'
        }
    },
    {
        path: '/log/activity-log',
        component: lazy(() => import('../views/my-activity')),
        meta: {
            action: 'call',
            resource: 'LOG_VIEW_MY_ACTIVITY'
        }
    },
    {
        path: '/log/user-activity-log',
        component: lazy(() => import('../views/user-activity')),
        meta: {
            action: 'call',
            resource: 'LOG_VIEW_USER_ACTIVITY'
        }
    }
]

